import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Home = ({
  onStartQuiz,
  onRestartQuiz,
  onContinueQuiz,
  wrongQuestions,
  sla,
  hasExistingQuiz,
  onLogout
}) => {
  const [selectedValue, setSelectedValue] = useState('SalesforceCertifiedAdministrator');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.zoom = '1';
  }, []);

  const handleSelect = (value) => {
    setSelectedValue(value);
  };

  const examOptions = [
    { 
      value: 'SalesforceCertifiedAdministrator', 
      label: '認定アドミニストレータ', 
      icon: 'admin_panel_settings',
      available: true,
      badge: 'free'
    },
    { 
      value: 'SalesforcePlatformAppBuilder', 
      label: 'プラットフォームアップビルダー', 
      icon: 'build',
      available: sla === 'basic' || sla === 'exective',
      badge: 'standard'
    },
    { 
      value: 'SalesforcePlatformDeveloperI', 
      label: 'プラットフォームデベロッパー', 
      icon: 'code',
      available: sla === 'basic' || sla === 'exective',
      badge: 'standard'
    },
    { 
      value: 'SalesforceSalesCloud', 
      label: 'SalesCloudコンサルタント', 
      icon: 'trending_up',
      available: sla === 'exective',
      badge: 'premium'
    },
    { 
      value: 'Service Cloudコンサルタント', 
      label: 'ServiceCloudコンサルタント', 
      icon: 'support_agent',
      available: sla === 'exective',
      badge: 'premium'
    },
    { 
      value: 'Experience Cloudコンサルタント JPN', 
      label: 'ExperienceCloudコンサルタント', 
      icon: 'groups',
      available: sla === 'exective',
      badge: 'premium'
    },
    { 
      value: '上級アドミニストレーター JPN', 
      label: '上級アドミニストレーター', 
      icon: 'verified',
      available: sla === 'exective',
      badge: 'premium'
    },
    { 
      value: 'DataCloudコンサルタント JPN', 
      label: 'DataCloudコンサルタント', 
      icon: 'cloud',
      available: sla === 'exective',
      badge: 'premium'
    },
    {
      value: 'FieldServiceコンサルタント JPN', 
      label: 'FieldServiceコンサルタント', 
      icon: '',
      available: sla === 'exective',
      badge: 'premium'
    }
  ];

  const handleLogout = () => {
    onLogout();
  };

  return (
    <div className="home-container card">
      <header className="home-header">
        <div className="home-title">
          <h1>Salesforce参考問題集</h1>
          <span className="version-tag">version 1.0.1</span>
        </div>
        <button onClick={handleLogout} className="button button-secondary logout-button">
          ログアウト
        </button>
      </header>

      <section className="update-info">
        <h3>更新情報</h3>
        <div className="update-content">
          <ul>
            <li data-version="v1.0.1">
              デザインの微調整およびバグの修正
            </li>
            <li data-version="v1.0.0">
              ログイン状況が保持されるようになりました。<br />※フリープランは対象外
            </li>
            <li data-version="v1.0.0">
              続きから問題を開始する機能の追加<br />※ログイン状況が保持されているときのみ有効
            </li>
            <li data-version="v1.0.0">
              ログアウト機能の追加
            </li>
          </ul>
        </div>
      </section>

      <section className="exam-selection">
        <h3>試験を選択</h3>
        <div className="exam-grid">
          {examOptions.map((option) => (
            <div
              key={option.value}
              className={`exam-card ${!option.available ? 'disabled' : ''} ${selectedValue === option.value ? 'selected' : ''}`}
              onClick={() => option.available && handleSelect(option.value)}
            >
              <span className="material-icons-round exam-icon">{option.icon}</span>
              <h4>{option.label}</h4>
              <span className={`badge ${option.badge}-badge`}>
                {option.badge}
              </span>
            </div>
          ))}
        </div>
      </section>

      {wrongQuestions?.length > 0 && (
        <section className="wrong-questions">
          <h3>間違えた問題</h3>
          <div className="wrong-numbers">
            {wrongQuestions.map((question, index) => (
              <div key={index} className="wrong-question-item">
                No.{question.number}
              </div>
            ))}
          </div>
        </section>
      )}

      <div className="action-buttons">
        <button 
          onClick={() => onStartQuiz(selectedValue)} 
          className="button"
        >
          試験開始
        </button>
        {hasExistingQuiz && (
          <button onClick={onContinueQuiz} className="button button-secondary">
            続きから
          </button>
        )}
        {wrongQuestions?.length > 0 && (
          <button onClick={onRestartQuiz} className="button button-secondary">
            間違えた問題に挑戦
          </button>
        )}
      </div>
    </div>
  );
};

Home.propTypes = {
  onStartQuiz: PropTypes.func.isRequired,
  onRestartQuiz: PropTypes.func.isRequired,
  onContinueQuiz: PropTypes.func.isRequired,
  wrongQuestions: PropTypes.array,
  sla: PropTypes.string.isRequired,
  hasExistingQuiz: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired
};

export default Home;
